import { api } from '@/lib/trpc/react';
import { useWorkspaceActions } from './useWorkspace';

export const useMakeFolderPrivate = () => {
  const { updateChatbot } = useWorkspaceActions();
  const utils = api.useUtils();

  return api.sidebar.makeFolderPrivate.useMutation({
    // Optimistically update the workspace cache
    onMutate: async ({ id }) => {
      // Snapshot previous workspace data
      const prevData = utils.workspace.all.getData();

      // Move folder to root level and remove team association in cache
      updateChatbot(id, { teamId: null, groupId: null });

      return { prevData };
    },
    // Rollback in case of error
    onError: (_err, _variables, context) => {
      if (context?.prevData) {
        utils.workspace.all.setData(undefined, context.prevData);
      }
    },
  });
};
